<div class="card card-statistics mb-30">
  <div class="card-body">

    <div *ngIf="Edit_Set_Value_List_Index==-1">



      <h5 class="card-title">فرم ثبت اطلاعات گواهی نامه</h5>
      <form>
        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> شماره رسید </label>
            <input value="{{Calibration_Device.dsc}}" disabled type="text" class="form-control">
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> نام دستگاه </label>
            <input value="{{Calibration_Device.device_name}}" disabled type="text" class="form-control">
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> کد دستگاه </label>
            <input value="{{Calibration_Device.device_code}}" disabled type="text" class="form-control">
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> سریال دستگاه </label>
            <input value="{{Calibration_Device.device_serial}}" disabled type="text" class="form-control">
          </div>
        </div>
      </form>

      <br />
      <hr />
      <br />

      <form>
        <div class="row">
          <div class="form-group col-md-12">
            <label for="exampleInputEmail1"> Certificate Code </label>
            <input value="{{CertificateCode}}" disabled type="text" class="form-control">
          </div>

        </div>
      </form>

      <br />
      <hr />
      <br />

      <form>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> بارگذاری فایل : </label>
            <input type="file" #file_excel>
          </div>
          <div class="form-group col-md-6">
            <img *ngIf="Procssing_Import" src="assets/Loading.gif" style="width: 25px;" />
            <button *ngIf="!Procssing_Import" type="button" class="btn btn-warning"
              (click)="upload_file_excel(file_excel.files)"> بارگذاری فایل <i class="fa fa-upload"></i></button>
          </div>
        </div>
      </form>

      <br />
      <hr />
      <br />

    </div>

    <h5 *ngIf="Edit_Set_Value_List_Index!=-1" class="card-title">فرم ویرایش اطلاعات Set value</h5>

    <form [formGroup]="MainFormDataEntity">
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Reference Value Before Adjustment </label>
          <input formControlName="Reference_Value" type="number" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_Reference_Value().valid && get_Form_Reference_Value().touched"
            class="form-text text-muted MyErrorRedColor">Reference Value Before Adjustment را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Sample’s Indication Before Adjustment </label>
          <input formControlName="Set_Value" type="number" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_Set_Value().valid && get_Form_Set_Value().touched"
            class="form-text text-muted MyErrorRedColor">Sample’s Indication Before Adjustment را وارد نمائید.</small>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Sample’s Indication Max </label>
          <input formControlName="Sample_Indication_Max" type="number" class="form-control"
            placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_Sample_Indication_Max().valid && get_Form_Sample_Indication_Max().touched"
            class="form-text text-muted MyErrorRedColor">Sample’s Indication Max را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Sample’s Indication Min </label>
          <input formControlName="Sample_Indication_Min" type="number" class="form-control"
            placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_Sample_Indication_Min().valid && get_Form_Sample_Indication_Min().touched"
            class="form-text text-muted MyErrorRedColor">Sample’s Indication Min را وارد نمائید.</small>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Reference Value Center Max </label>
          <input formControlName="Reference_Value_Center_Max" type="number" class="form-control"
            placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_Reference_Value_Center_Max().valid && get_Form_Reference_Value_Center_Max().touched"
            class="form-text text-muted MyErrorRedColor">Reference Value Center Max را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Reference Value Center Min </label>
          <input formControlName="Reference_Value_Center_Min" type="number" class="form-control"
            placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_Reference_Value_Center_Min().valid && get_Form_Reference_Value_Center_Min().touched"
            class="form-text text-muted MyErrorRedColor">Reference Value Center Min را وارد نمائید.</small>
        </div>
      </div>
    </form>

    <br />
    <hr />
    <br />

    <form [formGroup]="DetailFormDataEntity" (submit)="DetailFormDataEntity_Submit()">
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Reference Value Position {{DetailDataEntity_List.length+1}} Max </label>
          <input formControlName="Reference_Value_Position_Max" type="number" class="form-control"
            placeholder="اینجا تایپ کنید ...">
          <small
            *ngIf="!get_Form_Reference_Value_Position_Max().valid && get_Form_Reference_Value_Position_Max().touched"
            class="form-text text-muted MyErrorRedColor">Reference Value Position {{DetailDataEntity_List.length+1}} Max
            را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Reference Value Position {{DetailDataEntity_List.length+1}} Min </label>
          <input formControlName="Reference_Value_Position_Min" type="number" class="form-control"
            placeholder="اینجا تایپ کنید ...">
          <small
            *ngIf="!get_Form_Reference_Value_Position_Min().valid && get_Form_Reference_Value_Position_Min().touched"
            class="form-text text-muted MyErrorRedColor">Reference Value Position {{DetailDataEntity_List.length+1}} Min
            را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-4">

          <button type="submit" [disabled]="!DetailFormDataEntity.valid" class="btn btn-success"
            style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افزودن Reference Value Position </button>
        </div>
      </div>
    </form>
    <div class="table-responsive" *ngIf="DetailDataEntity_List.length>0">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>Reference Value Position Max</th>
            <th>Reference Value Position Min</th>
            <th>امکانات</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of DetailDataEntity_List">
            <td>{{DetailDataEntity_List.indexOf(item)+1}}</td>
            <td>
              <input type="text" style="width: 70px;"
                name="reference_Value_Position_Max_{{DetailDataEntity_List.indexOf(item)}}"
                [(ngModel)]="item.reference_Value_Position_Max">
            </td>
            <td>
              <input type="text" style="width: 70px;"
                name="reference_Value_Position_Min_{{DetailDataEntity_List.indexOf(item)}}"
                [(ngModel)]="item.reference_Value_Position_Min">
            </td>
            <td>
              <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                <div class="btn-group" role="group">
                  <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    امکانات
                  </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <a style="cursor: pointer;"
                      (click)="DetailDataEntity_List_Delete(DetailDataEntity_List.indexOf(item))"
                      class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                  </div>
                </div>
              </div>
            </td>

          </tr>
        </tbody>
      </table>
    </div>

    <br />
    <hr />
    <br />

    <button type="button" (click)="MainFormDataEntity_Submit()" *ngIf="Edit_Set_Value_List_Index==-1"
      [disabled]="!MainFormDataEntity.valid || DetailDataEntity_List.length==0 " class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افزودن Set Value </button>

    <button type="button" (click)="MainFormDataEntity_Submit()" *ngIf="Edit_Set_Value_List_Index!=-1"
      [disabled]="!MainFormDataEntity.valid || DetailDataEntity_List.length==0 " class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-edit"></i> ویرایش Set Value </button>

    <br />

    <div *ngIf="Edit_Set_Value_List_Index==-1">

      <div class="table-responsive" *ngIf="MainDataEntity_List.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Reference Value Before Adjustment</th>
              <th>Sample’s Indication Before Adjustment</th>
              <th>Sample’s Indication Max</th>
              <th>Sample’s Indication Min</th>
              <th>Reference Value Center Max</th>
              <th>Reference Value Center Min</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of MainDataEntity_List">
              <tr>

                <td>{{MainDataEntity_List.indexOf(item)+1}}</td>
                <td>{{item.reference_Value}}</td>
                <td>{{item.set_Value}}</td>
                <td>{{item.sample_Indication_Max}}</td>
                <td>{{item.sample_Indication_Min}}</td>
                <td>{{item.reference_Value_Center_Max}}</td>
                <td>{{item.reference_Value_Center_Min}}</td>
                <td>
                  <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                    <div class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        امکانات
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                        <a style="cursor: pointer;" *ngIf="!item.observation_visible"
                          (click)="observation_visible_Value_List(MainDataEntity_List.indexOf(item))"
                          class="dropdown-item"><i class="fa fa-eye"></i> مشاهده جزئیات </a>
                        <a style="cursor: pointer;" *ngIf="item.observation_visible"
                          (click)="observation_visible_Value_List(MainDataEntity_List.indexOf(item))"
                          class="dropdown-item"><i class="fa fa-eye-slash"></i> عدم مشاهده جزئیات </a>

                        <a style="cursor: pointer;" (click)="Edit_Set_Value_List(MainDataEntity_List.indexOf(item))"
                          class="dropdown-item"><i class="fa fa-edit"></i> ویرایش </a>
                        <a style="cursor: pointer;"
                          (click)="MainDataEntity_List_Delete(MainDataEntity_List.indexOf(item))"
                          class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                      </div>
                    </div>
                  </div>
                </td>

              </tr>
              <tr *ngIf="item.observation_visible">
                <td colspan="8">
                  <table class="mb-0 table table-bordered table-3 text-center table-striped">
                    <thead style="background-color: #39649b; color: white;">
                      <tr>
                        <th>#</th>
                        <th>Reference Value Position Max</th>
                        <th>Reference Value Position Min</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let itemdetail of item.detail">
                        <td>{{item.detail.indexOf(itemdetail)+1}}</td>
                        <td>{{itemdetail.reference_Value_Position_Max}}</td>
                        <td>{{itemdetail.reference_Value_Position_Min}}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>

      <br />
      <hr />
      <br />

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">
            تصاویر ضمینه
            <button (click)="Remove_uploadImage1()" type="button" *ngIf="UploadImageSrc" class="btn  btn-danger"><i
                class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_Image1" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_Image1" #file_Image1 (change)="uploadImage1(file_Image1.files)" type="file"
            class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>
      </div>

      <button type="button" (click)="Add_uploadImage1()" [disabled]="!UploadImageSrc" class="btn btn-info"
        style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افزودن تصویر </button>

      <br />

      <div class="table-responsive" *ngIf="UploadImageSrc_List.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>عکس</th>

              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of UploadImageSrc_List">

              <td>{{UploadImageSrc_List.indexOf(item)+1}}</td>
              <td>
                <img style="width: 150px;" src="{{BaseUrl}}File/Certificate/image/{{item}}" />
              </td>
              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a style="cursor: pointer;"
                        (click)="UploadImageSrc_List_Delete(UploadImageSrc_List.indexOf(item))" class="dropdown-item"><i
                          class="fa fa-remove"></i> حذف </a>
                    </div>
                  </div>
                </div>
              </td>

            </tr>
          </tbody>
        </table>
      </div>

      <br *ngIf="canAdd_SubmitDATEOFISSUE_Date" />
      <hr *ngIf="canAdd_SubmitDATEOFISSUE_Date" />
      <br *ngIf="canAdd_SubmitDATEOFISSUE_Date" />

      <div class="row" *ngIf="canAdd_SubmitDATEOFISSUE_Date">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">
            Date of Issue
          </label>
          <input type="date" [(ngModel)]="SubmitDATEOFISSUE_Date" class="form-control"
            placeholder="اینجا تایپ کنید ...">
        </div>

        <div class="form-group col-md-6">
          <button type="button" (click)="onSubmitDATEOFISSUE()" class="btn btn-info" style="margin-left: 5px;"><i
              class="fa  fa-plus-circle"></i> ثبت تاریخ </button>
        </div>
      </div>

      <br />
      <hr />
      <br />

      <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!InProccessing && !CertificateCode" type="button" (click)="onSubmit(templateCode)"
        class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات گواهی نامه
      </button>
      <button *ngIf="!InProccessing && CertificateCode" type="button" (click)="onSubmit(templateCode)"
        class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-edit"></i> ویرایش اطلاعات گواهی نامه </button>
      <a target="_blank" *ngIf="!InProccessing && CertificateCode" href="{{BaseUrl}}" style="margin-left: 5px;"
        class="btn btn-success"><i class="fa fa-file-pdf-o"></i> PDF </a>
      <button routerLink="/KartableInbox" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i
          class="fa fa-mail-reply"></i> بازگشت </button>
    </div>
  </div>
</div>

<ng-template #templateCode>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> کد گواهی نامه </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Code.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <p>کد گواهی نامه فرم کالبیراسیون کد گواهی نامه <b>'{{CertificateCode}}'</b></p>
  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-danger" (click)="modalRef_Code.hide()">بستن</button>
  </div>
</ng-template>
